import api from '@/api';
import { addNotificationDanger } from '@/store/slices/notificationsSlice';
import { TEvent } from '@/types/events';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getEvents = createAsyncThunk<TEvent[]>(
    'events/getEvents',
    async (_, thunkAPI) => {
        try {
            return await api.events.getEventsList();
        } catch (e) {
            thunkAPI.dispatch(addNotificationDanger({ text: e as string }));
            return [];
        }
    },
);

export const getUserEvents = createAsyncThunk<TEvent[]>(
    'events/getUserEvents',
    async (_, thunkAPI) => {
        try {
            let result = await api.events.getUserEvents();
            result = result.sort((a, b) => b.id - a.id);
            return result;
        } catch (e) {
            thunkAPI.dispatch(addNotificationDanger({ text: e as string }));
            return [];
        }
    },
);

export const getEventsByUser = createAsyncThunk<{ id: number, events: TEvent[] }, number>(
    'events/getEventsByUser',
    async (id, thunkAPI) => {
        try {
            const events = await api.events.getEventsByUser(id);
            return {
                id,
                events,
            };
        } catch (e) {
            thunkAPI.dispatch(addNotificationDanger({ text: e as string }));
            return {
                id,
                events: [],
            };
        }
    },
);
